module.exports = __webpack_public_path__ + "static/media/contact.465cc87f.png";